import { useRouter } from "next/router";
import React from "react";
export function useDebugMode() {
  const router = useRouter();
  return React.useMemo(() => {
    if (!router.isReady) {
      return false;
    }
    const debug = router.query.debug;
    if (Array.isArray(debug)) {
      return debug.includes("true");
    }
    return debug === "true";
  }, [router.isReady, router.query.debug]);
}